// @flow

import React from "react";
import { Field } from "react-final-form";
import FormSection from "../FormSection";

type DisabledSectionProps = {
  id: number,
  index: number,
  text: string
};

const DisabledSection = ({ id, index, text }: DisabledSectionProps) => {
  const disabledSection = `disabled${id}`;

  return (
    <FormSection
      id={disabledSection}
      index={index}
      title="..."
      validatedFields={[disabledSection]}
      withSeparator
      disabled
    >
      <Field name={disabledSection} validate={() => "error"} render={() => null} />
      {text}
    </FormSection>
  );
};

DisabledSection.defaultProps = {
  text: "Bitte treffen Sie alle notwendigen Auswahlmöglichkeiten."
};

export default DisabledSection;
